// ═══════════════════════════════════════════════════════════════
// quotaApi.js — État palier / quotas (chantier #5 / backend #2-#3)
// ═══════════════════════════════════════════════════════════════

const getToken = () => localStorage.getItem('oracle_token');

// Vue consolidée : { cercle, role, subscription{tier,status,active},
//   messages{current,max,unlimited}, projects{...}, features{studio,connectors,zk,voice} }
export async function getQuota() {
    const res = await fetch('/api/quota/me', {
        headers: { 'Authorization': `Bearer ${getToken()}` },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
}
